import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-page-content,div[app-page-content]',
  host: {
    '[class.no-gap]': 'nogap',
  },
  template: `
      <ng-content/>
      `,
  styles: `
    :host {
        position: relative;
        width: calc(100% - 6rem);
        margin: 0 3rem 0.5rem 3rem;
        padding: 0 0 0.5rem 0;
        display: flex;
        flex-direction: column;
        gap: 2rem;

        &.no-gap {
          gap: 0.25rem;
        }
    }
  `,
})
export class PageContentComponent {
  @Input() nogap?: boolean

}
